import React from 'react';
import ImgIconComp from '../../imgcomp';
import { useTranslation } from 'react-i18next';
const JiraIntegrationPopupHeader = props => {
    const { t } = useTranslation()

    return (
        <div className="login-jira-header">
            <div className="jira-logo">
                <div className="login-jira-logo-container">
                    <div className="icon icon-Jira-logo-24px"></div>
                    <div>{t('Connect Jira Instance')}</div>
                </div>
                <div className="clickable" onClick={() => props.closePopup(true)}>
                    <ImgIconComp id="close" class="jiraLogoExtraMar" />
                </div>
            </div>
            <hr />
        </div>
    )
};

export default JiraIntegrationPopupHeader;